// src/components/value-proposition-banner/value-proposition-banner.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment DisclosureDetailsFragment on EGDSUnorderedList {\n    listItems {\n      ... on HomeTextLinkListItem {\n        text\n        subText\n        action {\n          resource {\n            value\n          }\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      ... on EGDSTextStandardListItem {\n        text\n        subText\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment ValuePropositionBannerDisclosureFragment on ValuePropositionBannerDisclosure {\n    content {\n      header {\n        ... on EGDSBasicSectionHeading {\n          heading {\n            text\n          }\n          graphic {\n            ... on Icon {\n              description\n            }\n          }\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      details {\n        ...DisclosureDetailsFragment\n      }\n    }\n    icon {\n      description\n      id\n    }\n    openAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    id\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...IconFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment DisclosureCardCarouselItemFragment on ValuePropBannerCardItem {\n    card {\n      ... on EGDSStandardMessagingCard {\n        message\n        links {\n          text\n          action {\n            resource {\n              value\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n            accessibility\n            target\n            useRelativePath\n          }\n          size\n        }\n        graphic {\n          ...UIGraphicFragment\n        }\n        impressionTracking {\n          linkName\n          referrerId\n        }\n      }\n    }\n    disclosure {\n      ... on ValuePropositionBannerDisclosure {\n        ...ValuePropositionBannerDisclosureFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCardCarouselItemFragment on EGDSCardCarouselItem {\n    card {\n      ... on EGDSStandardMessagingCard {\n        message\n        links {\n          text\n          action {\n            resource {\n              value\n            }\n            analytics {\n              linkName\n              referrerId\n            }\n            accessibility\n            target\n            useRelativePath\n          }\n          size\n        }\n        graphic {\n          ...UIGraphicFragment\n        }\n        impressionTracking {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n    }\n    previousButton {\n      accessibility\n    }\n    items {\n      ... on EGDSCardCarouselItem {\n        ...EGDSCardCarouselItemFragment\n      }\n      ... on ValuePropBannerCardItem {\n        ...DisclosureCardCarouselItemFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    heading\n    message\n    links {\n      text\n      action {\n        resource {\n          value\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n        accessibility\n        target\n        useRelativePath\n      }\n      size\n    }\n    background\n    graphic {\n      ...UIGraphicFragment\n    }\n    impressionTracking {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment ValuePropositionBannerGridFragment on ValuePropositionBannerGrid {\n    items {\n      ... on EGDSStandardMessagingCard {\n        ...EGDSStandardMessagingCardFragment\n      }\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query ValuePropositionBannerQuery($context: ContextInput!, $placementId: String) {\n    valuePropositionBanner(context: $context, placementId: $placementId) {\n      header {\n        text\n      }\n      carousel {\n        ...EGDSCarouselFragment\n      }\n      grid {\n        ...ValuePropositionBannerGridFragment\n      }\n      disclosure {\n        ...ValuePropositionBannerDisclosureFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import React10 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewLarge, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard4 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText5 } from "uitk-react-text";
// src/components/value-proposition-banner/__private/__fragments/disclosure.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/value-proposition-banner/__private/__fragments/disclosure-details.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var DisclosureDetails = function(param) {
    var data = param.data;
    var listItems = data.listItems;
    var clickTracker = useClickTracker();
    if (listItems.length === 0) {
        return null;
    }
    var handleLinkClick = function(referrerId, linkName) {
        clickTracker(referrerId, linkName);
    };
    var items = listItems.map(function(item, index) {
        if (item.__typename === "HomeTextLinkListItem") {
            var _item_action_analytics = item.action.analytics, referrerId = _item_action_analytics.referrerId, linkName = _item_action_analytics.linkName;
            return /* @__PURE__ */ React.createElement(UitkSpacing, {
                padding: {
                    blockstart: index === 0 ? void 0 : "six"
                },
                key: "disclosure-item-".concat(index)
            }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkText, {
                size: 400,
                weight: "bold"
            }, item.text), /* @__PURE__ */ React.createElement(UitkLink, {
                size: "large",
                onClick: function() {
                    return handleLinkClick(referrerId, linkName);
                }
            }, /* @__PURE__ */ React.createElement("a", {
                href: item.action.resource.value
            }, item.subText))));
        }
        if (item.__typename === "EGDSTextStandardListItem") {
            return /* @__PURE__ */ React.createElement(UitkSpacing, {
                padding: {
                    blockstart: index === 0 ? void 0 : "six"
                },
                key: "disclosure-item-".concat(index)
            }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkText, {
                size: 400,
                weight: "bold"
            }, item.text), /* @__PURE__ */ React.createElement(UitkText, {
                size: 400
            }, item.subText)));
        }
        return null;
    });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, items);
};
DisclosureDetails.fragment = fragment;
DisclosureDetails.displayName = "DisclosureDetails";
// src/components/value-proposition-banner/__private/__fragments/disclosure.tsx
var fragment2 = gql2(_templateObject1(), DisclosureDetails.fragment);
var Disclosure = function(param) {
    var data = param.data, bannerHeading = param.bannerHeading;
    var _content_details, _content_header_graphic;
    var icon = data.icon, openAnalytics = data.openAnalytics, content = data.content;
    var clickTracker = useClickTracker2();
    var triggerRef = React2.useRef(null);
    var dialogId = React2.useMemo(function() {
        return Math.floor(Math.random() * 1e6);
    }, []);
    var _useDialog = _sliced_to_array(useDialog("centered-sheet-dialog-layer-".concat(dialogId)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var openDialog = function() {
        dialogActions.openDialog();
        if (openAnalytics) {
            clickTracker(openAnalytics.referrerId, openAnalytics.linkName);
        }
    };
    var closeDialog = function() {
        dialogActions.closeDialog();
        if (content.closeAnalytics) {
            clickTracker(content.closeAnalytics.referrerId, content.closeAnalytics.linkName);
        }
    };
    if (!icon || ((_content_details = content.details) === null || _content_details === void 0 ? void 0 : _content_details.__typename) !== "EGDSUnorderedList" || content.header.__typename !== "EGDSBasicSectionHeading") {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkLink2, {
        inline: true,
        domRef: triggerRef
    }, /* @__PURE__ */ React2.createElement("button", {
        onClick: openDialog,
        type: "button",
        "data-stid": "disclosure-btn"
    }, /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, "".concat(bannerHeading, " ").concat(content.header.heading.text)), /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: icon.id,
        size: UitkIconSize.EXTRA_SMALL
    })), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: icon.id,
        size: UitkIconSize.EXTRA_SMALL
    })))))), /* @__PURE__ */ React2.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React2.createElement(DialogComponent, null, /* @__PURE__ */ React2.createElement(UitkSheet, {
        centeredSheetSize: "small",
        type: "centered",
        triggerRef: triggerRef,
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React2.createElement(UitkToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: ((_content_header_graphic = content.header.graphic) === null || _content_header_graphic === void 0 ? void 0 : _content_header_graphic.__typename) === "Icon" ? content.header.graphic.description : void 0
        },
        toolbarTitle: content.header.heading.text
    }), /* @__PURE__ */ React2.createElement(UitkSheetContent, null, /* @__PURE__ */ React2.createElement(DisclosureDetails, {
        data: content.details
    }))))));
};
Disclosure.fragment = fragment2;
Disclosure.displayName = "Disclosure";
// src/components/value-proposition-banner/__private/__fragments/egds-carousel.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkCarousel } from "uitk-react-carousel";
// src/components/value-proposition-banner/__private/__fragments/disclosure-card-carousel-item.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { IntersectionTracker, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// src/utils/helper.ts
import { useLocation } from "react-router-dom";
var Redirecturl = function(redirectPath) {
    var queryParams = "";
    var _useLocation = useLocation(), pathname = _useLocation.pathname, search = _useLocation.search, hash = _useLocation.hash;
    var newPathname = pathname.concat(search, hash);
    queryParams = "?uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(newPathname)));
    return redirectPath + queryParams;
};
// src/components/value-proposition-banner/__private/__fragments/ui-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// src/components/value-proposition-banner/__private/__fragments/icon.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var fragment3 = gql3(_templateObject2());
var Icon = function(param) {
    var data = param.data, size = param.size;
    var id = data.id;
    return /* @__PURE__ */ React3.createElement(Viewport2, null, /* @__PURE__ */ React3.createElement(ViewSmall2, null, /* @__PURE__ */ React3.createElement(UitkIcon2, {
        name: id,
        size: size !== null && size !== void 0 ? size : UitkIconSize2.LARGE
    })), /* @__PURE__ */ React3.createElement(ViewMedium2, null, /* @__PURE__ */ React3.createElement(UitkIcon2, {
        name: id,
        size: size !== null && size !== void 0 ? size : UitkIconSize2.XLARGE
    })));
};
Icon.fragment = fragment3;
Icon.displayName = "Icon";
// src/components/value-proposition-banner/__private/__fragments/ui-graphic.tsx
var fragment4 = gql4(_templateObject3(), Icon.fragment);
var UIGraphic = function(param) {
    var data = param.data, iconOptions = param.iconOptions;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(Icon, _object_spread({
                data: data
            }, iconOptions));
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment4;
// src/components/value-proposition-banner/__private/__fragments/disclosure-card-carousel-item.tsx
var fragment5 = gql5(_templateObject4(), Disclosure.fragment, UIGraphic.fragment);
var DisclosureCardCarouselItem = function(param) {
    var data = param.data, isContentOnStart = param.isContentOnStart, isLanding = param.isLanding;
    var _card_links, _card_graphic;
    var card = data.card, disclosure = data.disclosure;
    var trackClick = useClickTracker3();
    if (card.__typename !== "EGDSStandardMessagingCard") {
        return null;
    }
    var usedLinks = (_card_links = card.links) === null || _card_links === void 0 ? void 0 : _card_links.map(function(linkItem, index) {
        var action = linkItem.action;
        var target = (action === null || action === void 0 ? void 0 : action.target) === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self";
        var onClickButton = function() {
            var _action_analytics, _action_analytics1;
            trackClick(action === null || action === void 0 ? void 0 : (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.referrerId, action === null || action === void 0 ? void 0 : (_action_analytics1 = action.analytics) === null || _action_analytics1 === void 0 ? void 0 : _action_analytics1.linkName);
        };
        if (!action.resource) {
            return null;
        }
        return /* @__PURE__ */ React5.createElement(UitkSpacing2, {
            key: index,
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React5.createElement(UitkLink3, {
            onClick: onClickButton
        }, /* @__PURE__ */ React5.createElement("a", {
            href: Redirecturl(action.resource.value),
            target: target,
            rel: "noopener"
        }, linkItem.text)));
    });
    var cardContent = /* @__PURE__ */ React5.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            block: "six",
            inline: "two"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlex2, {
        space: "four",
        alignItems: isContentOnStart ? "start" : "center"
    }, ((_card_graphic = card.graphic) === null || _card_graphic === void 0 ? void 0 : _card_graphic.__typename) === "Icon" && /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UIGraphic, {
        data: card.graphic
    }))), /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(Viewport3, null, /* @__PURE__ */ React5.createElement(ViewSmall3, null, /* @__PURE__ */ React5.createElement(React5.Fragment, null, card.message && /* @__PURE__ */ React5.createElement(UitkText2, {
        size: 300,
        weight: isLanding ? "bold" : "regular"
    }, card.message, " ", disclosure && /* @__PURE__ */ React5.createElement(Disclosure, {
        data: disclosure
    })), card.links && card.links.length > 0 && /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React5.createElement("span", null, usedLinks)))), /* @__PURE__ */ React5.createElement(ViewMedium3, null, /* @__PURE__ */ React5.createElement(React5.Fragment, null, card.message && /* @__PURE__ */ React5.createElement(UitkText2, {
        size: 400
    }, card.message, " ", disclosure && /* @__PURE__ */ React5.createElement(Disclosure, {
        data: disclosure
    })), card.links && card.links.length > 0 && /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React5.createElement("span", null, usedLinks))))))))));
    return /* @__PURE__ */ React5.createElement(UitkCard, {
        padded: true
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem, {
        alignSelf: isContentOnStart ? "start" : "center"
    }, card.impressionTracking ? /* @__PURE__ */ React5.createElement(IntersectionTracker, {
        referrerId: card.impressionTracking.referrerId,
        linkName: card.impressionTracking.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, cardContent) : cardContent)));
};
DisclosureCardCarouselItem.fragment = fragment5;
DisclosureCardCarouselItem.displayName = "EGDSCardCarouselItem";
// src/components/value-proposition-banner/__private/__fragments/egds-card-carousel-item.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment6 = gql6(_templateObject5(), UIGraphic.fragment);
var EGDSCardCarouselItem = function(param) {
    var data = param.data, isContentOnStart = param.isContentOnStart, isLanding = param.isLanding;
    var _card_links, _card_graphic;
    var card = data.card;
    var trackClick = useClickTracker4();
    if (card.__typename !== "EGDSStandardMessagingCard") {
        return null;
    }
    var usedLinks = (_card_links = card.links) === null || _card_links === void 0 ? void 0 : _card_links.map(function(linkItem, index) {
        var action = linkItem.action;
        var target = (action === null || action === void 0 ? void 0 : action.target) === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self";
        var onClickButton = function() {
            var _action_analytics, _action_analytics1;
            trackClick(action === null || action === void 0 ? void 0 : (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.referrerId, action === null || action === void 0 ? void 0 : (_action_analytics1 = action.analytics) === null || _action_analytics1 === void 0 ? void 0 : _action_analytics1.linkName);
        };
        if (!action.resource) {
            return null;
        }
        return /* @__PURE__ */ React6.createElement(UitkSpacing3, {
            key: index,
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React6.createElement(UitkLink4, {
            onClick: onClickButton
        }, /* @__PURE__ */ React6.createElement("a", {
            href: Redirecturl(action.resource.value),
            target: target,
            rel: "noopener"
        }, linkItem.text)));
    });
    var cardContent = /* @__PURE__ */ React6.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            block: "six",
            inline: "two"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex3, {
        space: "four",
        alignItems: isContentOnStart ? "start" : "center"
    }, ((_card_graphic = card.graphic) === null || _card_graphic === void 0 ? void 0 : _card_graphic.__typename) === "Icon" && /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(UIGraphic, {
        data: card.graphic
    }))), /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(Viewport4, null, /* @__PURE__ */ React6.createElement(ViewSmall4, null, /* @__PURE__ */ React6.createElement(React6.Fragment, null, card.message && /* @__PURE__ */ React6.createElement(UitkText3, {
        size: 300,
        weight: isLanding ? "bold" : "regular"
    }, /* @__PURE__ */ React6.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: card.message
        }
    })), card.links && card.links.length > 0 && /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React6.createElement("span", null, usedLinks)))), /* @__PURE__ */ React6.createElement(ViewMedium4, null, /* @__PURE__ */ React6.createElement(React6.Fragment, null, card.message && /* @__PURE__ */ React6.createElement(UitkText3, {
        size: 400
    }, /* @__PURE__ */ React6.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: card.message
        }
    })), card.links && card.links.length > 0 && /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React6.createElement("span", null, usedLinks))))))))));
    return /* @__PURE__ */ React6.createElement(UitkCard2, {
        padded: true
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex3, null, /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem2, {
        alignSelf: isContentOnStart ? "start" : "center"
    }, card.impressionTracking ? /* @__PURE__ */ React6.createElement(IntersectionTracker2, {
        referrerId: card.impressionTracking.referrerId,
        linkName: card.impressionTracking.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, cardContent) : cardContent)));
};
EGDSCardCarouselItem.fragment = fragment6;
EGDSCardCarouselItem.displayName = "EGDSCardCarouselItem";
// src/components/value-proposition-banner/__private/__fragments/egds-carousel.tsx
var fragment7 = gql7(_templateObject6(), DisclosureCardCarouselItem.fragment, EGDSCardCarouselItem.fragment);
var EGDSCarousel = function(props) {
    var data = props.data, isContentOnStart = props.isContentOnStart, isLanding = props.isLanding, _props_peek = props.peek, peek = _props_peek === void 0 ? false : _props_peek;
    var nextButton = data.nextButton, previousButton = data.previousButton, items = data.items;
    var carouselElements = items.map(function(item, index) {
        if (item.__typename === "EGDSCardCarouselItem") {
            return /* @__PURE__ */ React7.createElement(EGDSCardCarouselItem, {
                data: item,
                key: "value-proposition-carousel-card-".concat(index),
                isContentOnStart: isContentOnStart,
                isLanding: isLanding
            });
        }
        if (item.__typename === "ValuePropBannerCardItem") {
            return /* @__PURE__ */ React7.createElement(DisclosureCardCarouselItem, {
                data: item,
                key: "value-proposition-carousel-card-".concat(index),
                isContentOnStart: isContentOnStart,
                isLanding: isLanding
            });
        }
        return null;
    });
    var carouselProps = {
        itemsMaxHeight: true,
        carouselName: "ValuePropositionBannerCarousel",
        itemsVisible: {
            sm: 1,
            md: 3,
            lg: 3,
            xl: 3
        },
        pageBy: 1,
        peek: peek,
        buttonText: {
            nextButton: (nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) || "",
            prevButton: (previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) || ""
        },
        children: carouselElements,
        hideNav: true
    };
    return /* @__PURE__ */ React7.createElement(UitkCarousel, _object_spread({}, carouselProps));
};
EGDSCarousel.fragment = fragment7;
EGDSCarousel.displayName = "EGDSCarousel";
// src/components/value-proposition-banner/__private/__fragments/value-proposition-banner-grid.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
// src/components/value-proposition-banner/__private/__fragments/egds-standard-messaging-card.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard3, UitkCardBackgroundThemes, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText4 } from "uitk-react-text";
var fragment8 = gql8(_templateObject7(), UIGraphic.fragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data, isContentOnStart = param.isContentOnStart;
    var backgroundTheme = (data === null || data === void 0 ? void 0 : data.background) === "secondary" ? UitkCardBackgroundThemes.SECONDARY : UitkCardBackgroundThemes.PRIMARY;
    var links = data.links, impressionTracking = data.impressionTracking;
    var trackClick = useClickTracker5();
    var usedLinks = links === null || links === void 0 ? void 0 : links.map(function(linkItem, index) {
        var _linkItem_action_resource, _linkItem_action;
        var action = linkItem.action;
        var target = (action === null || action === void 0 ? void 0 : action.target) === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self";
        var onClickButton = function() {
            var _action_analytics, _action_analytics1;
            trackClick(action === null || action === void 0 ? void 0 : (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.referrerId, action === null || action === void 0 ? void 0 : (_action_analytics1 = action.analytics) === null || _action_analytics1 === void 0 ? void 0 : _action_analytics1.linkName);
        };
        if (!action.resource) {
            return null;
        }
        return /* @__PURE__ */ React8.createElement(UitkSpacing4, {
            key: index,
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React8.createElement(UitkLink5, {
            onClick: onClickButton
        }, /* @__PURE__ */ React8.createElement("a", {
            href: Redirecturl(linkItem === null || linkItem === void 0 ? void 0 : (_linkItem_action = linkItem.action) === null || _linkItem_action === void 0 ? void 0 : (_linkItem_action_resource = _linkItem_action.resource) === null || _linkItem_action_resource === void 0 ? void 0 : _linkItem_action_resource.value),
            target: target,
            rel: "noopener"
        }, linkItem.text)));
    });
    var cardContent = /* @__PURE__ */ React8.createElement(UitkLayoutFlex4, {
        direction: "column",
        justifyContent: isContentOnStart ? "start" : "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem3, {
        alignSelf: "start"
    }, /* @__PURE__ */ React8.createElement(UitkCardContentSection3, {
        padded: false
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex4, {
        alignItems: isContentOnStart ? "start" : "center",
        space: "four"
    }, data.graphic && /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(UIGraphic, {
        data: data === null || data === void 0 ? void 0 : data.graphic,
        iconOptions: {
            size: UitkIconSize3.LARGE
        }
    }))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React8.createElement("div", null, data.heading && /* @__PURE__ */ React8.createElement(UitkHeading, {
        tag: "h2",
        size: 7
    }, data.heading), data.message && /* @__PURE__ */ React8.createElement(UitkText4, {
        size: 400,
        weight: "medium"
    }, data.message), data.links && data.links.length > 0 && /* @__PURE__ */ React8.createElement(UitkSpacing4, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React8.createElement("span", null, usedLinks))))))));
    return /* @__PURE__ */ React8.createElement(UitkCard3, {
        backgroundTheme: backgroundTheme
    }, /* @__PURE__ */ React8.createElement(UitkSpacing4, {
        padding: "six"
    }, impressionTracking ? /* @__PURE__ */ React8.createElement(IntersectionTracker3, {
        referrerId: impressionTracking.referrerId,
        linkName: impressionTracking.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, cardContent) : cardContent));
};
EGDSStandardMessagingCard.fragment = fragment8;
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
// src/components/value-proposition-banner/__private/__fragments/value-proposition-banner-grid.tsx
var fragment9 = gql9(_templateObject8(), EGDSStandardMessagingCard.fragment);
var ValuePropositionBannerGrid = function(param) {
    var data = param.data, isContentOnStart = param.isContentOnStart;
    var items = data.items, analytics = data.analytics;
    if (items.length === 0) {
        return null;
    }
    var cards = items.map(function(item, index) {
        return /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, {
            key: "valueprop-grid-item-".concat(index)
        }, item.__typename === "EGDSStandardMessagingCard" ? /* @__PURE__ */ React9.createElement(EGDSStandardMessagingCard, {
            data: item,
            isContentOnStart: isContentOnStart
        }) : null);
    });
    return /* @__PURE__ */ React9.createElement(Viewport5, null, /* @__PURE__ */ React9.createElement(ViewSmall5, null, analytics ? /* @__PURE__ */ React9.createElement(IntersectionTracker4, {
        referrerId: analytics.referrerId,
        linkName: analytics.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
        columns: 1,
        space: "four"
    }, cards)) : /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
        columns: 1,
        space: "four"
    }, cards)), /* @__PURE__ */ React9.createElement(ViewMedium5, null, analytics ? /* @__PURE__ */ React9.createElement(IntersectionTracker4, {
        referrerId: analytics.referrerId,
        linkName: analytics.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
        columns: 3,
        space: "four"
    }, cards)) : /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
        columns: 3,
        space: "four"
    }, cards)));
};
ValuePropositionBannerGrid.fragment = fragment9;
ValuePropositionBannerGrid.displayName = "ValuePropositionBannerGridFragment";
// src/components/value-proposition-banner/value-proposition-banner.tsx
var __Query = gql10(_templateObject9(), EGDSCarousel.fragment, ValuePropositionBannerGrid.fragment, Disclosure.fragment);
var ValuePropositionBanner = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.valuePropositionBanner) {
        return null;
    }
    var _data_valuePropositionBanner = data.valuePropositionBanner, carousel = _data_valuePropositionBanner.carousel, disclosure = _data_valuePropositionBanner.disclosure, header = _data_valuePropositionBanner.header, grid = _data_valuePropositionBanner.grid;
    if ((grid === null || grid === void 0 ? void 0 : grid.items.length) === 0 && carousel.items.length === 0) {
        return null;
    }
    var gridView = grid && grid.items.length > 0;
    var isLanding = (inputs === null || inputs === void 0 ? void 0 : inputs.placementId) === "LANDING";
    return /* @__PURE__ */ React10.createElement(Viewport6, null, /* @__PURE__ */ React10.createElement(ViewSmall6, null, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: gridView ? "four" : {
            block: "six",
            inlinestart: "six",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React10.createElement(UitkCard4, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, {
        space: gridView ? void 0 : "two",
        direction: "column"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, {
        maxWidth: isLanding || gridView ? void 0 : "76x"
    }, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: {
            inlineend: "three"
        },
        margin: gridView ? {
            blockend: "four"
        } : void 0
    }, /* @__PURE__ */ React10.createElement(UitkHeading2, {
        tag: "h2"
    }, /* @__PURE__ */ React10.createElement(UitkText5, {
        inline: true,
        size: isLanding || gridView ? 500 : 400,
        weight: gridView ? "medium" : "bold"
    }, /* @__PURE__ */ React10.createElement(React10.Fragment, null, "".concat(header.text, " "), disclosure && /* @__PURE__ */ React10.createElement(Disclosure, {
        data: disclosure,
        bannerHeading: header.text
    })))))), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        margin: gridView ? void 0 : {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React10.createElement("div", null, carousel && /* @__PURE__ */ React10.createElement(EGDSCarousel, {
        isContentOnStart: isLanding,
        data: carousel,
        isLanding: isLanding,
        peek: true
    }), grid && /* @__PURE__ */ React10.createElement(ValuePropositionBannerGrid, {
        data: grid,
        isContentOnStart: isLanding
    })))))))), /* @__PURE__ */ React10.createElement(ViewMedium6, null, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: gridView ? "four" : {
            block: "three",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React10.createElement(UitkCard4, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, {
        space: gridView ? void 0 : "two",
        alignItems: gridView ? "start" : "center",
        direction: gridView ? "column" : void 0
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, {
        maxWidth: gridView ? void 0 : "76x"
    }, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: gridView ? void 0 : {
            inlinestart: "twelve"
        },
        margin: gridView ? {
            blockend: "four"
        } : {
            inlineend: "six"
        }
    }, /* @__PURE__ */ React10.createElement(UitkHeading2, {
        tag: "h2",
        size: 4
    }, /* @__PURE__ */ React10.createElement(React10.Fragment, null, "".concat(header.text, " "), disclosure && /* @__PURE__ */ React10.createElement(Disclosure, {
        data: disclosure,
        bannerHeading: header.text
    }))))), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, gridView ? /* @__PURE__ */ React10.createElement(ValuePropositionBannerGrid, {
        data: grid,
        isContentOnStart: isLanding
    }) : /* @__PURE__ */ React10.createElement(EGDSCarousel, {
        isContentOnStart: isLanding,
        data: carousel,
        peek: true
    })))))), /* @__PURE__ */ React10.createElement(ViewLarge, null, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: gridView ? "four" : {
            block: "three",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React10.createElement(UitkCard4, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, {
        alignItems: "center",
        space: gridView ? void 0 : "four"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, {
        maxWidth: gridView ? void 0 : "76x"
    }, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        padding: gridView ? {
            block: "three",
            inlinestart: "three"
        } : {
            inlinestart: "twelve"
        },
        margin: gridView ? {
            inlineend: "four"
        } : {
            inlineend: "six"
        }
    }, /* @__PURE__ */ React10.createElement(UitkHeading2, {
        tag: "h2",
        size: 4
    }, /* @__PURE__ */ React10.createElement(React10.Fragment, null, "".concat(header.text, " "), disclosure && /* @__PURE__ */ React10.createElement(Disclosure, {
        data: disclosure,
        bannerHeading: header.text
    }))))), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, gridView ? /* @__PURE__ */ React10.createElement(ValuePropositionBannerGrid, {
        data: grid,
        isContentOnStart: isLanding
    }) : /* @__PURE__ */ React10.createElement(EGDSCarousel, {
        isContentOnStart: isLanding,
        data: carousel,
        peek: true
    })))))));
};
ValuePropositionBanner.displayName = "sharedui-ValuePropositionBanner";
export { ValuePropositionBanner };
//# sourceMappingURL=index.js.map